import Grid from '@material-ui/core/Grid';
import * as React from 'react';
import { FormControl, Select, MenuItem, IconButton, FormControlLabel, Checkbox } from '@material-ui/core';
import PageComponent from './PageComponent';
import IconBackButton from '@material-ui/icons/KeyboardBackspace';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import ConfirmationComponent from 'src/components/common//notification/ConfirmationComponent';
import { PAGE_DELETE_CONFIRAMATION } from '../../constants/NotificationMessageConstant';

export default class QuestionComponent extends React.Component<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            errors: {},
            currentPageNumber: 1,
            editModuleMetadata: {},
            pages: [],
            validations: [],
            isValidated: false,
            isDeletePage: false
        };
        this.handlePageChange = this.handlePageChange.bind(this);
        this.updateModule = this.updateModule.bind(this);
        this.handleDiscard = this.handleDiscard.bind(this);
        this.handleIsSummary = this.handleIsSummary.bind(this);
        this.handleSaveProgress = this.handleSaveProgress.bind(this);
    }

    updateModule(data: any) {
        this.props.updateModule(data);
    }

    componentDidMount() {
        if (Object.keys(this.props.editModuleMetadata).length !== 0) {
            this.setState({
                editModuleMetadata: this.props.editModuleMetadata,
                pages: this.props.editModuleMetadata.moduleQuestion.pages
            });
        }

    }

    UNSAFE_componentWillReceiveProps(nextProps: any) {
        if (nextProps.editModuleMetadata && nextProps.editModuleMetadata.moduleQuestion) {
            this.setState({
                editModuleMetadata: nextProps.editModuleMetadata,
                pages: nextProps.editModuleMetadata.moduleQuestion.pages
            });
        }

    }

    handlePageChange = (event: any) => {
        if (event.target.value === 'newPage') {
            const newPage = this.buildNewPage()
            this.setState({
                currentPageNumber: this.state.pages.length + 1
            });
            this.props.updateModule({ data: newPage, field: 'newPage' })
        }
        else {
            this.setState({
                currentPageNumber: parseInt(event.target.value, 10),
                pages: this.props.editModuleMetadata.moduleQuestion.pages
            });
        }
    }

    onDeletePageChange = (pageNumber: number) => {
        this.setState({
            currentPageNumber: pageNumber, // this.state.pages.length,
            pages: this.props.editModuleMetadata.moduleQuestion.pages
        });
    }

    buildNewPage() {
        return {
            page_number: this.state.pages.length + 1,
            page_description: {
                en: ''
            },
            isdirty: true,
            issummary: false,
            question_clusters: [this.props.editModuleMetadata.moduleQuestion.base_question_cluster],
            title: {
                en: ''
            },
        };
    }

    handleDiscard = () => {
        this.props.path(`/module/${this.props.editModuleMetadata.module.id}`);
    }

    handleIsSummary(e: any) {
        const isSummary = e.target.checked;
        delete this.state.errors[`summaryPage_${this.props.editModuleMetadata.module && this.props.editModuleMetadata.module.name}`];
        this.props.updateModule({ data: { pageNumber: this.state.currentPageNumber, value: isSummary }, field: 'summaryPage' });
    }

    validateQuestions = () => {
        let errors = this.state.errors;
        if (this.state.pages && this.state.pages.length > 0) {
            let cluserIndex = 0;
            let questionIndex = 0;
            for (const page of this.state.pages) {
                const pageClusters = page.question_clusters
                if (!page.title.en) {
                    errors[`page_${page.page_number}`] = 'Page title is mandatory';
                }
                for (const cluster of pageClusters) {
                    for (const question of cluster.questions) {
                        if (!question.title.en) {
                            errors[`questionTitle_${page.page_number}${cluserIndex}${questionIndex}`] = 'Question name is mandatory';
                        }
                        if (question.input_type > 3 && question.input_type < 7) {
                            errors = this.validateOptions(question, cluserIndex, questionIndex, errors, page.page_number);
                        }
                        questionIndex++;
                    }
                    questionIndex = 0;
                    cluserIndex++;
                }
                questionIndex = 0;
                cluserIndex = 0;

            }
        }

        this.setState({ isValidated: true, errors });
        return errors;
    }

    validateOptions = (question: any, cluserIndex: number, questionIndex: number, errors: any, pageNumber: any) => {
        if (!question.items || question.items.length === 0) {
            errors[`questionOption_${pageNumber}${cluserIndex}${questionIndex}`] = 'Question options are mandatory';
        }
        else {
            for (const item of question.items) {
                for (const choice of item.choices) {
                    if (!choice.text.en) {
                        errors[`questionOptionText_${pageNumber}${cluserIndex}${questionIndex}`] = 'Queston option text is mandatory to fill.';
                    }
                    if (!choice.value) {
                        errors[`questionOptionValue_${pageNumber}${cluserIndex}${questionIndex}`] = 'Queston option value is mandatory to fill.';
                    }
                }
            }
        }

        return errors;
    }

    handleSaveProgress = () => {
        const errors = this.validateQuestions();
        if (Object.keys(errors).length === 0 && errors.constructor === Object) {
            this.props.saveQuestions();
            setTimeout(() => {
                this.resetDirty();
            }, 100);
        }
        else {
            this.setState(errors);
            window.scrollTo(0, 0);
        }
    }

    resetDirty = () => {
        if (this.state.pages && this.state.pages.length > 0) {
            for (const page of this.state.pages) {
                page.isdirty = false;
                for (const cluster of page.question_clusters) {
                    cluster.isdirty = false;
                    for (const question of cluster.questions) {
                        question.isdirty = false;
                    }
                }
            }

            this.setState({ pages: this.state.pages });
        }
    }

    // delete page
    deletePage = () => {
        this.setState({
            isDeletePage: true
        })
    }

    // close confirm dialog
    handleCloseConfirmation = () => {
        this.setState({
            isDeletePage: false
        })
    }

    // handle yes confim button click event
    handleDeletePageConfimYesButton = (pageNumber: number) => {
        this.props.updateModule({
            data: {
                pageNumber
            },
            field: 'deletePage'
        });

        setTimeout(() => this.onDeletePageChange(1), 100);
        this.handleCloseConfirmation()
    }

    render() {
        const metadata = this.state.editModuleMetadata;
        const moduleCategory = this.props.editModuleMetadata.moduleQuestion &&
            this.props.editModuleMetadata.moduleQuestion.module_categories
                .find((mc: any) => mc.key === this.props.editModuleMetadata.module.module_category_id);
        const moduleType = this.props.editModuleMetadata.moduleQuestion &&
            this.props.editModuleMetadata.moduleQuestion.module_types
                .find((mc: any) => mc.key === this.props.editModuleMetadata.module.module_type_id);
        const moduleCategoryName = moduleCategory ? moduleCategory.value : '';
        const moduleTypeName = moduleType ? moduleType.value : '';

        return (
            <>
                <div className="pageHeading">
                    <Grid container={true} spacing={8}>
                        <Grid item={true} xs={8}>
                            <div className="pageTitleSection">
                                <IconButton className="backButton" color="inherit" aria-label="Open drawer" onClick={this.handleDiscard}>
                                    <IconBackButton />
                                </IconButton>
                                <div className="pageBreadcrumb">
                                    <ul>
                                        <li className="listItem">
                                            <a href="javascript:void(0)">{moduleTypeName}</a>
                                            <IconButton className="arrowRight" color="inherit" aria-label="Arrow Right">
                                                <KeyboardArrowRight />
                                            </IconButton>
                                        </li>
                                        {
                                            moduleCategoryName && (
                                                <li className="listItem">
                                                    <a href="javascript:void(0)">
                                                        {moduleCategoryName}
                                                    </a>
                                                    <IconButton className="arrowRight" color="inherit" aria-label="Arrow Right">
                                                        <KeyboardArrowRight />
                                                    </IconButton>
                                                </li>
                                            )
                                        }
                                        <li className="listItem">
                                            <a href="javascript:void(0)" className="active">{this.props.editModuleMetadata.module && this.props.editModuleMetadata.module.name}</a>
                                        </li>
                                    </ul>
                                </div>

                            </div>
                        </Grid>
                        <Grid item={true} xs={4}>
                            <div className="pagesLinks text-right">
                                <ul>
                                    <li className="listItem">
                                        <a href="javascript:void(0)" className="linkRed" onClick={this.handleDiscard}>Discard Draft</a>
                                    </li>
                                    <li className="listItem">
                                        <a href="javascript:void(0)" onClick={this.handleSaveProgress}>Save Progress</a>
                                    </li>
                                </ul>
                            </div>
                        </Grid>
                        <Grid item={true} xs={2}>
                            <div className="pagesSection">
                                <label>Pages: </label>
                                <FormControl margin="normal" fullWidth={true} className="pageMenuItem">
                                    <Select
                                        value={this.state.currentPageNumber}
                                        onChange={this.handlePageChange}
                                    >
                                        {
                                            this.state.pages.map((pg: any) => {
                                                return (
                                                    <MenuItem key={pg.page_number} value={pg.page_number}>Page {pg.page_number}</MenuItem>
                                                )
                                            })
                                        }
                                        <MenuItem key='newPage' value='newPage'>+Add New Page</MenuItem>
                                    </Select>
                                </FormControl>
                            </div>
                        </Grid>
                        <Grid item={true} xs={2}>
                            <div className='DeletePageAlign'>
                            <a href="javascript:void(0)" onClick={() => this.deletePage()}>Delete Current Page</a>
                            </div>
                            
                        </Grid>
                        <Grid item={true} xs={8} className="text-right no-pad">
                            <span>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            name='issummery'
                                            checked={this.state.pages[this.state.currentPageNumber - 1] ? this.state.pages[this.state.currentPageNumber - 1].issummary : false}
                                            onChange={this.handleIsSummary}
                                        />
                                    }
                                    label="Mark as summary page"
                                />
                            </span>
                        </Grid>
                    </Grid>
                    <ConfirmationComponent
                        handleDialogSubmit={() => this.handleDeletePageConfimYesButton(this.state.currentPageNumber)}
                        message={PAGE_DELETE_CONFIRAMATION}
                        open={this.state.isDeletePage}
                        onCloseConfirmation={() => this.handleCloseConfirmation()}
                    />
                </div>
                {
                    Object.keys(metadata).length !== 0 &&
                    <div className="pageContent">
                        <PageComponent
                            allData={this.props.editModuleMetadata}
                            currentPage={this.state.pages[this.state.currentPageNumber - 1]}
                            updateModule={this.updateModule}
                            moduleId={this.props.moduleId}
                            errors={this.state.errors}
                            getModuleList={this.props.getModuleList}
                            modules={this.props.modules}
                            onDeletePageChange={this.onDeletePageChange}
                            userId={this.props.userId}
                        />
                    </div>
                }
            </>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/questions/QuestionComponent.tsx